import QRCode from "qrcode";
import SolicitudesService from "../services/SolicitudesService";

export const generarDataUrlQR = async (idSolicitudInput, token = "") => {
  try {
    let tokenFinal = token;

    let param = typeof idSolicitudInput === "object"
      ? (idSolicitudInput?.idSolicitud || idSolicitudInput?.codigo || idSolicitudInput?.orden || idSolicitudInput?.id)
      : idSolicitudInput;

    if (!tokenFinal && param) {
      try {
        const resToken = await SolicitudesService.getQrToken(param);
        if (resToken?.data?.token) {
          tokenFinal = resToken.data.token;
        }
      } catch (errToken) {
        console.warn("No se pudo obtener token JWT para QR:", errToken);
      }
    }

    if (!tokenFinal) {
      console.warn("No se pudo generar un token válido para el QR.");
      return null;
    }

    let baseUrl = process.env.REACT_APP_FRONTEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
    if (!baseUrl || baseUrl.includes(":4000")) {
      baseUrl = process.env.REACT_APP_PUBLIC_DOMAIN || "https://laboratoriosgarcia.cloud";
    }
    baseUrl = baseUrl.replace(/\/$/, "");

    // URL generada conteniendo ÚNICAMENTE el Token encriptado JWT
    const qrUrl = `${baseUrl}/consultaweb/qr/${tokenFinal}`;

    const dataUrl = await QRCode.toDataURL(qrUrl, {
      margin: 1,
      width: 250,
      color: {
        dark: "#18234F",
        light: "#FFFFFF",
      },
    });
    return dataUrl;
  } catch (err) {
    console.error("Error generando QR DataURL:", err);
    return null;
  }
};
